import { TransactionTypeEnum, currencies } from '@/components/TableTransactions/transactionsTypes.ts';
import { BankingCategoryItemEntity, CounterpartyEntity } from '@/generated/graphql.ts';

const UNCATEGORIZED = 'uncategorized';

export function getTransactionTypeClass(transactionType?: string): string {
  if (transactionType === TransactionTypeEnum.Outcoming) {
    return 'text-red-10';
  } else if (transactionType === TransactionTypeEnum.Incoming) {
    return 'text-green-10';
  }
  return '';
}

export function filterCategory(bankingCategoryItem: BankingCategoryItemEntity): string {
  if (!bankingCategoryItem || bankingCategoryItem.name === null || bankingCategoryItem.name.trim() === '') {
    return '';
  }

  const lowerCaseName = bankingCategoryItem.name.toLowerCase();
  if (lowerCaseName.includes(UNCATEGORIZED)) {
    return '';
  }
  return bankingCategoryItem.name;
}

export function formaterAccountInfo(accountName: string, currency: string): string {
  if (!accountName && !currency) return '';
  if (!accountName) return `(${currency})`;
  if (!currency) return accountName;
  return `${accountName} (${currency})`;
}

function getCurrencySymbol(currency: string): string {
  const currencyInfo = currencies.find(c => c.code === currency);
  return currencyInfo ? currencyInfo.symbol : currency;
}

export function formatTransactionAmount(amount: string | null, currency: string | null, transactionType?: string): string {
  if (!amount || !currency) {
    return '';
  }

  const symbol = getCurrencySymbol(currency);

  const parsedAmount = parseFloat(amount);
  if (isNaN(parsedAmount)) {
    return '';
  }

  const formattedAmount = Math.abs(parsedAmount).toFixed(2);

  if (transactionType === TransactionTypeEnum.Outcoming) {
    return `-${symbol}${formattedAmount}`;
  } else if (transactionType === TransactionTypeEnum.Incoming) {
    return `${symbol}${formattedAmount}`;
  }

  return `${symbol}${formattedAmount}`;
}

export function formatSourceAmount(sourceAmount: string | null, sourceCurrency: string | null): string {
  if (!sourceAmount || !sourceCurrency) {
    return '';
  }

  const symbol = getCurrencySymbol(sourceCurrency);

  const parsedAmount = parseFloat(sourceAmount);
  if (isNaN(parsedAmount)) {
    return '';
  }

  const formattedAmount = parsedAmount.toFixed(2);

  if (parsedAmount < 0) {
    return `-${symbol}${Math.abs(parsedAmount).toFixed(2)}`;
  }
  return `${symbol}${formattedAmount}`;
}

export const formatNumberValue = (value: number | null | undefined): string => {
  if (value == null) return '';

  const parsedAmount = parseFloat(value.toString());
  if (isNaN(parsedAmount)) {
    return '';
  }

  if (parsedAmount < 0) {
    return `-${Math.abs(parsedAmount).toFixed(2)}`;
  }
  return parsedAmount.toFixed(2);
};

export function formaterCounterparty(
  counterpartyName?: string | null,
  counterpartyId?: string | null,
  counterparty?: CounterpartyEntity | null,
): string {
  if (counterpartyName) return counterpartyName;
  if (!counterpartyId) return '';

  if (counterparty) {
    const { firstName, lastName, middleName } = counterparty;
    if (firstName) {
      return [firstName, lastName, middleName].filter(Boolean).join(' ');
    }
  }

  return '';
}
